<div class="page-header">
  <div class="create-report">
    <h2>Create Report</h2>
    <div class="create-options">
      @for (option of createOptions; track option.title) {
        <ng-container *ngIf="!option.disabled; else disabledOption">
          <a class="create-option" [routerLink]="option.route">
            <img class="icon" [src]="option.icon" />
            <div class="content">
              <h3>{{ option.title }}</h3>
              <p>{{ option.description }}</p>
            </div>
          </a>
        </ng-container>
    
        <ng-template #disabledOption>
          <div class="create-option disabled">
            <img class="icon" [src]="option.icon" />
            <div class="content">
              <h3>{{ option.title }}</h3>
              <p>{{ option.description }}</p>
            </div>
          </div>
        </ng-template>
      }
    </div>
    
  </div>
  <div class="quarter-data">
    <div class="chart-data" style="padding-top:2rem;">
      <div class="chart-container">
        <canvas #reportChart></canvas>
      </div>
    </div>
    <div class="legends">
      <div *ngFor="let item of legendItems; let i = index" [class.inactive]="!item.active" (click)="toggleLegend(i)">
        {{ item.label }} ({{ item.value }})
      </div>
    </div>
    
  </div>
</div>